import TemplateView from '../../TemplateView'
import WorkflowStatus from '../WorkflowStatus'

export class WorkflowStatusNode extends TemplateView {
    constructor({
                    status,
                    checked
                },
                onClickStatus) {
        super(null)

        this.params = {
            status,
            onClickStatus,
            checked
        }
    }

    templateHtml() {
        return '<div class="workflowStatusNode"></div>'
    }

    afterRender() {
        new WorkflowStatus({
            ...this.params.status
        }).init(this.$el)

        this.$el
            .toggleClass('checked', this.params.checked)
            .click(this._handleClickStatus)
    }

    _handleClickStatus = () => {
        this.params.onClickStatus(this.params.status.id)
    }
}

export default WorkflowStatusNode



// WEBPACK FOOTER //
// ./web/js/workflowStatus/components/WorkflowStatusNode.js